// src/core/errors.ts

export class LoggerError extends Error {
  constructor(
    message: string,
    public readonly cause?: Error
  ) {
    super(message);
    this.name = "LoggerError";
  }
}

export class StreamError extends LoggerError {
  constructor(message: string, cause?: Error) {
    super(`Stream Error: ${message}`, cause);
    this.name = "StreamError";
  }
}

export class SerializationError extends LoggerError {
  constructor(
    message: string,
    public readonly data: unknown,
    cause?: Error
  ) {
    super(`Serialization Error: ${message}`, cause);
    this.name = "SerializationError";
  }
}


export class ConfigurationError extends LoggerError {
  constructor(message: string, cause?: Error) {
    super(`Configuration Error: ${message}`, cause);
    this.name = "ConfigurationError";
  }
}

// Error handler type
export type ErrorHandler = (error: LoggerError) => void;

// Default error handler that ensures errors surface
export const defaultErrorHandler: ErrorHandler = (error: LoggerError) => {
  console.debug("[DEBUG] defaultErrorHandler received error:", { error });
  console.error(`[LOGGER ERROR] ${error.name}:`, {
    message: error.message,
    cause: error.cause,
    stack: error.stack,
  });

  // Only throw in development mode
  if (process.env.NODE_ENV === "development") {
    // In development, throw all errors except serialization errors
    if (!(error instanceof SerializationError)) {
      throw error;
    }
  } else {
    // In production, only throw critical errors
    if (error instanceof StreamError || error instanceof ConfigurationError) {
      throw error;
    }
  }
};
